<h2 mat-dialog-title>Pick a product</h2>
<mat-dialog-content class="picker-content">
  <product-catalog-list
    [isCatalog]="true"
    (onProductSelected)="onPicked($event)">
  </product-catalog-list>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>
</mat-dialog-actions>
